import Immutable from 'immutable';
import { createSelector } from 'reselect';

const getBrowseCategory = state => state.getIn(['browse', 'category'], Immutable.Map());

export const selectCategoryConfig = createSelector([getBrowseCategory], browseCategory => {
  return browseCategory.get('config', Immutable.Map());
});
export const selectIsFetching = createSelector([getBrowseCategory], browseCategory => {
  return browseCategory.get('isFetching', false);
});
